/**
 * Generates a unique trace ID.
 * @returns A string representing the trace ID.
 */
function generateTraceId(): string {
  return [...window.crypto.getRandomValues(new Uint8Array(16))]
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Generates a unique span ID.
 * @returns A string representing the span ID.
 */
function generateSpanId(): string {
  return [...window.crypto.getRandomValues(new Uint8Array(8))]
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export function generateTraceparent(): string {
  return `00-${generateTraceId()}-${generateSpanId()}-01`;
}
